module.exports = __webpack_public_path__ + "static/media/icon_investmentsoftware.494ce553.svg";